import React from 'react';
import './LikeButton.css';

export class LikeButton extends React.Component {

  static getButtonId (id) {
    return `like-button-${id}`;
  }

  static getIconId (id) {
    return `like-icon-${id}`;
  }

  render () {
    const { id, className } = this.props;
    return (
      <div className={ `presentation-animations ${!!className ? className : ''}` }>
        <button id={ LikeButton.getButtonId(id) } className="thumb_up">
          <svg
            id={ LikeButton.getIconId(id) }
            width="22px"
            height="20px"
            viewBox="0 0 22 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Live-View" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Artboard-2" transform="translate(-79.000000, -60.000000)">
                <g id="Group-3" transform="translate(64.000000, 46.000000)">
                  <path d="M15,33.1434297 L15,21.6573719 L18.8325618,21.6573719 L18.8325618,33.1434297 L15,33.1434297 Z M36.0790899,22.6145434 L36.0695085,22.6911171 L36.0790899,22.7006888 L36.0790899,24.5288863 C36.0790899,24.7777509 36.0311829,25.0074721 35.9449503,25.2276215 L33.0513661,31.9756805 C32.763924,32.6648439 32.0836442,33.1434297 31.2883877,33.1434297 L22.6651236,33.1434297 C21.6111691,33.1434297 20.7488427,32.2819753 20.7488427,31.2290867 L20.7488427,21.6573719 C20.7488427,21.1309276 20.9596336,20.6523418 21.3141456,20.3077601 L27.6187097,14 L28.6343386,15.0050301 C28.8930365,15.2634664 29.0559204,15.6271915 29.0559204,16.0196318 L29.0271762,16.3259267 L28.1169428,20.7002004 L34.162809,20.7002004 C35.2167635,20.7002004 36.0790899,21.5616547 36.0790899,22.6145434 Z" id="ic_thumb_up_Inactive" fill="#9AD170"></path>
                  <rect id="Rectangle-31" x="0" y="0" width="50" height="50"></rect>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    );
  }
}
